import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const CreateTestLabelSuccessSchema = z.object({
  success: z.literal(true),
  labelUrl: z.string(),
});

const CreateTestLabelFailureSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

export const createTestLabel = {
  name: "createTestLabel" as const,
  input: z.object({ teamId: zExt.objectId(), carrierAccountId: z.string() }),
  output: z.discriminatedUnion("success", [
    CreateTestLabelSuccessSchema,
    CreateTestLabelFailureSchema,
  ]),
};
